require('./RAStrategyCardsInfo.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @constants
const {
    CARD_ONE,
    CARD_TWO,
    CARD_THREE,
    CARD_FOUR,
    CARD_FIVE,
} = require('../../../raConstants/index');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { Portfolios } = require('../../../utilities/RAPortfolioHelper');

class RAStrategyCardsInfo extends React.PureComponent {
    getInvestmentStrategyLegalText(selectedCard) {
        let legalText;

        switch (selectedCard) {
            case CARD_ONE:
                legalText = (
                    <div>
                        <p>
                            <FormattedText value="RAStrategyCards_KualaLumpur-legalTextP1" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_KualaLumpur-legalTextP2" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_KualaLumpur-legalTextP3" />
                        </p>
                    </div>
                );
                break;
            case CARD_TWO:
                legalText = (
                    <div>
                        <p>
                            <FormattedText value="RAStrategyCards_Shanghai-legalTextP1" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_Shanghai-legalTextP2" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_Shanghai-legalTextP3" />
                        </p>
                    </div>
                );
                break;
            case CARD_THREE:
                legalText = (
                    <div>
                        <p>
                            <FormattedText value="RAStrategyCards_Taipei-legalTextP1" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_Taipei-legalTextP2" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_Taipei-legalTextP3" />
                        </p>
                    </div>
                );
                break;
            case CARD_FOUR:
                legalText = (
                    <div>
                        <p>
                            <FormattedText value="RAStrategyCards_NewYork-legalTextP1" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_NewYork-legalTextP2" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_NewYork-legalTextP3" />
                        </p>
                    </div>
                );
                break;
            case CARD_FIVE:
                legalText = (
                    <div>
                        <p>
                            <FormattedText value="RAStrategyCards_Dubai-legalTextP1" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_Dubai-legalTextP2" />
                        </p>
                        <p>
                            <FormattedText value="RAStrategyCards_Dubai-legalTextP3" />
                        </p>
                    </div>
                );
                break;
        }

        return legalText;
    }

    getRiskProfileLegalText() {
        return (
            <React.Fragment>
                <p>
                    <FormattedText value="RAStrategyCards-legalTextParagraph2" />
                </p>
                <div className="ra-strategy-cards-info__information">
                    <p>
                        <i className="icon ra-strategy-cards-info__information-icon" />
                        <FormattedText value="RAStrategyCards-legalTextP4" />
                    </p>
                    <p>
                        <i className="icon ra-strategy-cards-info__information-icon" />
                        <FormattedText value="RAStrategyCards-legalTextP5" />
                    </p>
                </div>
            </React.Fragment>
        );
    }

    getRiskLevel(selectedCard) {
        const lowRiskText = formatText('raStrategyItem-lowRisk');
        const midLowRisk = formatText('raStrategyItem-midLowRisk');
        const midRiskText = formatText('raStrategyItem-midRisk');
        const midHighRisk = formatText('raStrategyItem-midHighRisk');
        const highRiskText = formatText('raStrategyItem-highRisk');
        let riskLevel = '';

        switch (selectedCard) {
            case CARD_ONE:
                riskLevel = lowRiskText;
                break;
            case CARD_TWO:
                riskLevel = midLowRisk;
                break;
            case CARD_THREE:
                riskLevel = midRiskText;
                break;
            case CARD_FOUR:
                riskLevel = midHighRisk;
                break;
            case CARD_FIVE:
                riskLevel = highRiskText;
                break;
        }

        riskLevel = riskLevel.replace(/\b\w/g, text => text.toUpperCase()); // Capitalize

        return riskLevel;
    }

    getSelectedCardInfo(card, riskLevel) {
        const iconClassName = classnames(
            'ra-strategy-cards-info__icon-product',
            `ra-strategy-cards-info__icon-product--${card}`,
        );

        return (
            <div className="ra-strategy-cards-info__selected-portfolio-card">
                <div className={iconClassName} />
                <div className="ra-strategy-cards-info__selected-portfolio-info">
                    <FormattedText
                        className="ra-strategy-cards-info__selected-portfolio-name"
                        value={`RAStrategyCards-portfolio${card}`}
                    />
                    <span className="ra-strategy-cards-info__risk-category">
                        {riskLevel}
                    </span>
                </div>
            </div>
        );
    }

    getAvailableStrategies(card) {
        const items = [];

        for (let i = 1; i < card; i++) {
            if (Portfolios[i].portfolioId !== card) {
                items.push(Portfolios[i]);
            }
        }

        return (
            <div className="ra-strategy-cards-info__available-portfolio-section">
                {items.map((ite, index) => {
                    const strategyId = ite.portfolioId;
                    const iconClassName = classnames(
                        'ra-strategy-cards-info__icon-product',
                        `ra-strategy-cards-info__icon-product--${strategyId}`,
                    );
                    const riskLevel = this.getRiskLevel(strategyId);
                    return (
                        <div
                            className="ra-strategy-cards-info__available-portfolio-card"
                            key={index}
                        >
                            <div className={iconClassName} />
                            <div className="ra-strategy-cards-info__available-portfolio-info">
                                <FormattedText
                                    className="ra-strategy-cards-info__available-portfolio-name"
                                    value={`RAStrategyCards-portfolio${strategyId}`}
                                />
                                <span className="ra-strategy-cards-info__risk-category">
                                    {riskLevel}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    render() {
        const { clientName, suitableProfile, selectedCard } = this.props;
        const riskLevelSuitableProfile = this.getRiskLevel(suitableProfile);
        const riskLevel = !!selectedCard
            ? this.getRiskLevel(selectedCard)
            : this.getRiskLevel(suitableProfile);
        const card = !!selectedCard ? selectedCard : suitableProfile;
        const investmentStrategyLegalText = this.getInvestmentStrategyLegalText(
            card,
        );
        const riskProfileLegalText = this.getRiskProfileLegalText();
        const selectedCardInfo = this.getSelectedCardInfo(card, riskLevel);
        const availableStrategyInfo = this.getAvailableStrategies(
            suitableProfile,
            riskLevel,
        );

        return (
            <BlockInfo extraClass="ra-suitability-test-zero-question-legal-text__block-info">
                <p>
                    <FormattedText
                        value="RAStrategyCards-legalTextP1"
                        injectedStrings={[
                            clientName,
                            suitableProfile,
                            riskLevelSuitableProfile,
                        ]}
                    />
                </p>
                <p>
                    <FormattedText
                        value="RAStrategyCards-legalTextP3"
                        injectedStrings={[riskLevel, riskLevel]}
                    />
                </p>
                <div className="ra-strategy-cards-info__strategies-wrapper">
                    {selectedCardInfo}
                    {availableStrategyInfo}
                </div>
                {investmentStrategyLegalText}
                {riskProfileLegalText}
            </BlockInfo>
        );
    }
}

RAStrategyCardsInfo.propTypes = {
    clientName: PropTypes.string.isRequired,
    selectedCard: PropTypes.number.isRequired,
    suitableProfile: PropTypes.number,
};

module.exports = RAStrategyCardsInfo;
